<div *ngIf="canAccessScreen" class="card mt-1">
    <div class="card-header text-center d-flex align-items-center">
        <h3 class="flex-fill" paflabel="Connexions_fournisseurs"></h3>
        <button class="btn btn-sm btn-success mx-1" type="button" (click)="excelExport.save()"
            [disabled]="LstCnxs.length==0"><i class="far fa-file-excel mr-1"></i>Exporter</button>
    </div>
    <div class="card-body small">
        <kendo-grid 
            #grid
            class="grid-condensed header-wrap"
            [data]="gridDatas" 
            [pageSize]="state.take" 
            [skip]="state.skip" 
            [sort]="state.sort"
            [sortable]="true" 
            [pageable]="pagerSettings" 
            [height]="500"
            [filterable]="'menu'"
            [filter]="state.filter" 
            (sortChange)="sortChange($event)"
            (pageChange)="pageChange($event)"
            (dataStateChange)="dataStateChange($event)" 
            [selectable]="selectableSettings"
            [resizable]="true">
            <!-- <kendo-grid-column-group title="Connexions utilisateurs"> -->
                <kendo-grid-column field="CnxId" class="text-right" title="" [width]="0" [sortable]="false" [filterable]="false">
                    <ng-template kendoGridGroupHeaderTemplate let-group let-field="field" let-value="value">
                        <strong>{{GroupHeaderLib(value)}}</strong>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="DateLogin" class="text-center" title="Dernière connexion"  [format]="{ datetime: 'short' }" [width]="150" filter="date">
                </kendo-grid-column>
                <kendo-grid-column field="Email" title="Email" [sortable]="true"  [width]="200">
                </kendo-grid-column>
                <kendo-grid-column field="Lastname" title="Nom"  [sortable]="true"  [width]="200">
                </kendo-grid-column>
                <kendo-grid-column field="Firstname" title="Prénom"  [sortable]="true"  [width]="200">
                </kendo-grid-column>
            <!-- </kendo-grid-column-group> -->
            <!-- <kendo-grid-column-group title="Fournisseur(s)"> -->
                <kendo-grid-column field="StatutLib" title="Statut du fournisseur" [width]="250"></kendo-grid-column>
                <kendo-grid-column field="SupplierName" [sortable]="true" title="Fournisseur" >
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" let-column="column">
                        <a class="control-label" [routerLink]="getSupplierLink(dataItem)" [paftooltip]="'Fiche_fournisseur'" target="_blank">
                        {{ dataItem.SupplierName }}
                        </a>
                    </ng-template>
                </kendo-grid-column>
                <kendo-grid-column field="NumTiers" title="Tiers" [width]="150"> 
                    <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex" let-column="column">
                        <div style="text-align: right; width:100%;">
                        <a class="control-label"  [routerLink]="getSupplierLink(dataItem)" [paftooltip]="'Fiche_fournisseur'" target="_blank">
                        {{ dataItem.NumTiers }}
                        </a></div>
                    </ng-template>
                </kendo-grid-column>
            <!-- </kendo-grid-column-group> -->
        </kendo-grid>
            <kendo-excelexport [fileName]="excelFilename" [data]="LstCnxs" [filterable]="true" #excelExport>
                <kendo-excelexport-column field="DateLogin" title="Dernière connexion"  [cellOptions]="{ format: 'dd/mm/yyyy hh:mm;@' }"></kendo-excelexport-column>
                <kendo-excelexport-column field="Email" title="Email"></kendo-excelexport-column>
                <kendo-excelexport-column field="Lastname" title="Nom"></kendo-excelexport-column>
                <kendo-excelexport-column field="Firstname" title="Prénom"></kendo-excelexport-column>
                <kendo-excelexport-column field="StatutLib" title="Statut du fournisseur"></kendo-excelexport-column>
                <kendo-excelexport-column field="SupplierName" title="Fournisseur"></kendo-excelexport-column>
                <kendo-excelexport-column field="NumTiers" title="Tiers"></kendo-excelexport-column>
            </kendo-excelexport>
    </div>
</div>
<div *ngIf="!canAccessScreen">
    <non-admin-lock-panel></non-admin-lock-panel>
</div>